const u = (r, s) => {
  const i = 2 * Math.PI * s * r;
  return i / (i + 1);
}, c = (r, s, i) => r * s + (1 - r) * i;
class O {
  constructor({ minCutOff: s, beta: i }) {
    this.minCutOff = s, this.beta = i, this.dCutOff = 1e-3, this.xPrev = null, this.dxPrev = null, this.tPrev = null, this.initialized = !1;
  }
  reset() {
    this.initialized = !1;
  }
  filter(s, i) {
    const n = Array.isArray(i), e = n ? i : [i];
    if (!e.every(Number.isFinite))
      return n ? this.xPrev ?? e : (this.xPrev ?? e)[0];
    if (this.initialized && !this.xPrev.every(Number.isFinite) && (this.initialized = !1), !this.initialized)
      return this.initialized = !0, this.xPrev = e, this.dxPrev = e.map(() => 0), this.tPrev = s, n ? e : e[0];
    const { xPrev: h, tPrev: v, dxPrev: P } = this, a = s - v;
    if (a <= 0)
      return n ? h : h[0];
    const d = u(a, this.dCutOff), f = [], l = [], o = [];
    for (let t = 0; t < e.length; t++) {
      f[t] = (e[t] - h[t]) / a, l[t] = c(d, f[t], P[t]);
      const x = this.minCutOff + this.beta * Math.abs(l[t]), m = u(a, x);
      o[t] = c(m, e[t], h[t]);
    }
    return this.xPrev = o, this.dxPrev = l, this.tPrev = s, n ? o : o[0];
  }
}
export {
  O
};
